import * as React from 'react';

export class JIRASvg extends React.Component<{}> {

  render() {
    return (
      <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          xmlSpace="preserve"
      >
        <g id="Layer_3"/>
        <g id="Layer_1">
          <path fill="#D7D8D9" d="M35.2,3.3C35.2,3.3,35.1,3.2,35.2,3.3C35.1,3.2,35.2,3.3,35.2,3.3L35.2,3.3z"/>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <g>
                        <circle fill="#1C2E5B" cx="25" cy="25" r="24"/>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <path
                    fill="#EAEAE9"
                    d="M13.3,16.6c0,0-0.2,4.1,6.8,11c7,6.8,7.8,11,7.4,11h5.1c0,0,0.5-7.4-7.4-13c0,0-5.4-4.5-6.3-8.4c0,0-2.7,
                    0.1-4.5-1.4C14.3,15.9,13.3,15.4,13.3,16.6z"
                />
                <g>
                  <path
                      fill="#EAEAE9"
                      d="M24.1,27.4c1.4,1,2.5,2.1,3.5,3.1c0.7-0.7,1.4-1.5,2.3-2.3c7-6.8,6.8-11.7,6.8-11.7c0-1.2-1-0.5-1-0.5c-1.9,1.5-4.5,1.5-4.5,
                      1.5c-0.9,3.8-6.3,8.7-6.3,8.7c-0.4,0.3-0.7,0.5-1,0.8C24,27.3,24.1,27.4,24.1,27.4z"
                  />
                  <path
                      fill="#EAEAE9"
                      d="M24.1,34.2c-0.9-1.2-2.1-2.9-3.7-4.5c-3.2,4.7-3,8.9-3,8.9h5.1C22.2,38.6,22.4,36.6,24.1,34.2z"
                  />
                </g>
                <path
                    fill="#EAEAE9"
                    d="M22.4,17.2h5c0,0,0.7,0.3,0.5,1.1c-0.2,1.2-2.9,3.9-2.9,3.9s-2-2.1-2.9-3.8C22.1,18.5,21.8,17.2,22.4,17.2z"
                />
                <circle fill="#EAEAE9" cx="31.6" cy="12.7" r="2.2"/>
                <circle fill="#EAEAE9" cx="18.7" cy="12.7" r="2.2"/>
                <circle fill="#EAEAE9" cx="25.2" cy="11" r="2.2"/>
              </g>
            </g>
          </g>
        </g>
        <g id="Layer_2"/>
      </svg>

    )
  }
}